(function ($) {
	'use strict';

	$(function () {
		new Masonry({
			'.members_list': {
				columnWidth: 340
			}
		});

		setup_member_list_filter();

		$('.country-filter').on('click', '.choice:not(.inactive)', function () {
			var $t = $(this);
			$('.country-filter .choice').removeClass('active');
			$t.addClass('active');

			var char = $t.is('li') ? $t.text() : '*';
			filter_member_list(char);
		});

		$('.eden-tabs li').on('shown.bs.tab', function () {
			$(document).trigger('masonRefresh');
		});

		$('#keynotes form').on('change', 'select', function () {
			$('#keynotes form').submit();
		});

		$('a.to_modal').on('click', loadInModal);
	});

	// to prevent paginate_links generated links from
	// wreaking havoc...
	$(document).on('click', '.ajax-navigation a', function (e) {
		e.preventDefault();
	});

	function Masonry(options) {
		var _this = this;
		var containers = $('[class*="-container"].masonry')
			.each(function () {
				var selector = '.' + $(this)
					.attr('class')
					.match(/\b([\w-]+)-container\b/)[1];

				var mopt = {
					itemSelector: selector,
					gutter: 20,
					fitWidth: true
				};

				if (options && typeof options[selector] === 'object') {
					$.extend(mopt, options[selector]);
				}

				$(this).masonry(mopt);

			});

		this.layout = function () {
			containers.masonry('layout');
		};

		this.refresh = function () {
			_this.layout();
			containers.imagesLoaded(_this.layout);
		};

		// needed because of webfont loading
		$(window).load(_this.refresh);

		// react to others calls
		$(document).on('masonRefresh', _this.refresh);
	}

	// ajax navigation
	$(document).on('click',
		'.ajax-navigation, .ajax-control',
		function ajax_post_load(e) {
			var post = {action: 'wam_ajax_postlist'},
			$this = $(this);

			post.args = $this.data('args');
			post.options = $this.data('options');

			/* if we have more button, target should be set
			 othervise we're gonna replace the parent's content */
			var target = $this.data('target') || $this.parent(),
				more = 'more' === post.options.type;

			if (more) {
				// auto next page if we have only more button
				post.args.paged++;
				// and save it to the element
				$this.data('args', post.args);

			} else if ($this.hasClass('ajax-navigation')) {
				// if we have pagination
				var $t = $(e.target),
					href = $t.attr('href');

				// get the page from the clicked link's href
				post.args.paged = parseInt(href.slice(href.lastIndexOf('-') + 1));
			}

			// the ajax query
			$.ajax({
				success: function (response) {
					// create jquery object from response html
					// (needed for masonry appended, so why not here)
					var $t = $(target), elements;

					try {
						elements = $(response);
					} catch(err) {
						// non html string returned, possible no more posts
						$this.text(response);
						return;
					}

					$this.find('.spinner').addClass('hidden');

					if (more) {
						// if more, append elements to target
						$t.append(elements);
						// if target has masonry, update it...
						if ($t.data('masonry')) {
							$t.masonry('appended', elements);
							$(document).trigger('masonRefresh');
						}

					} else {
						// just empty target and load response
						$t.empty().append(elements);
					}
				},
				url: edenJs.ajaxurl,
				type: 'POST',
				dataType: 'html',
				data: post,
				beforeSend: function () {
					// show spinner before ajax send
					$this.find('.spinner').removeClass('hidden');
				},
			});
		});

	function setup_member_list_filter() {
		var $ml = $('.members_list h2');

		$('.country-filter li').each(function () {
			var $this = $(this),
				char = $this.text();

			if ($ml.filter(function () {
				return $(this).text().substr(0, 1).toLowerCase() === char.toLowerCase();
			}).length === 0) {
				$this.addClass('inactive');
			}
		});
	}

	function filter_member_list(char) {
		char = char.toLowerCase();

		$('.members_list').show();

		if ('*' !== char) {
			$('.members_list').each(function () {
				if ($(this).find('h2').text().substr(0, 1).toLowerCase() !== char) {
					$(this).hide();
				}
			});
		}

		$(document).trigger('masonRefresh');
	}

	function loadInModal(e) {
		e.preventDefault();
		var $t = $(e.target);
		$t.addClass('loading');

		var data = {
			action: 'wam_ajax_post',
			url: $t.attr('href'),
		};

		$.post(edenJs.ajaxurl, data, function (result) {
			$t.removeClass('loading');
			$('#popup').modal().find('.modal-body').html(result);
		});
	}

	// Keynote ajax loaderrr
	$(document).on('click',
		'.keynote-control',
		function ajax_keynote_load(e) {
			var $t = $(this),
				data = {
					keyword: $t.data('keyword'),
					conference_year: $t.data('conference_year'),
					conference_category: $t.data('conference_category'),
					limit: parseInt($t.data('limit')),
					action: 'eden_keynotes'
				};

			data.offset = parseInt($t.data('offset')) + data.limit;
			$t.data('offset', data.offset);
			$t.find('.spinner').removeClass('hidden');

			if (parseInt($t.data('count')) <= data.offset + data.limit) {
				$t.hide();
			}

			$.ajax({
				url: edenJs.ajaxurl,
				data: data,
				type: 'POST',
				dataType: 'html',
				success: function (result) {
					var target = $('.keynote-container.masonry'),
						elements = $(result);
					target.append(elements);
					target.masonry('appended', elements);
					$(document).trigger('masonRefresh');
					$('#keynote_filters .current').text(data.offset + elements.filter('.keynote').length);
				},
				complete: function () {
					$t.find('.spinner').addClass('hidden');
				},
			});

		});

})(jQuery);
